// React
import { useCallback } from 'react';
import { useLoaderData } from 'react-router-dom';

// Hooks
import { usePreviewData } from '@/hooks/usePreviewData';

// Services
import { getHeader } from '@/services/header/headerService';
import { getFooter } from '@/services/footer/footerService';
import { getHome } from '@/services/home/homeService';

// Components
import LayoutHeaderFooter from '@/components/layout/LayoutHeaderFooter/LayoutHeaderFooter';
import { PageBlocks } from '@/components/blocks/Blocks';

// Styles
import { Helmet } from 'react-helmet';
import styles from './Home.module.css';

export async function homeLoader() {
  const [header, footer, home] = await Promise.all([getHeader(), getFooter(), getHome()]);

  return {
    header,
    footer,
    home,
  };
}

function Home() {
  const loaderData = useLoaderData() as Awaited<ReturnType<typeof homeLoader>>;
  const refetch = useCallback(() => homeLoader(), []);
  const data = usePreviewData(loaderData, refetch);
  const baseUrl = import.meta.env.VITE_DOMAIN;

  if (!data) return null;

  const { header, footer, home } = data;

  if (!home) return null;

  return (
    <main>
      <Helmet>
        <title>{home.seo.metaTitle}</title>
        <meta name="description" content={home.seo.metaDescription} />
        <link rel="canonical" href={baseUrl} />
      </Helmet>
      <LayoutHeaderFooter header={header} footer={footer}>
        <div className={styles.body}>
          <PageBlocks blocks={home.blocks} />
        </div>
      </LayoutHeaderFooter>
    </main>
  );
}

export default Home;
